import { render } from "./TestimonialVariableFields.vue?vue&type=template&id=2aaf6bc7&scoped=true"
import script from "./TestimonialVariableFields.vue?vue&type=script&lang=js"
export * from "./TestimonialVariableFields.vue?vue&type=script&lang=js"

import "./TestimonialVariableFields.vue?vue&type=style&index=0&id=2aaf6bc7&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaf6bc7"]])

export default __exports__